const createSuspensionClockEvent = () => [
  { action: "copyEvent", value: "card", type: "to" },
  { action: "newEvent", value: null, type: "main" },
  {
    action: "saveData",
    value: "clock",
    type: "class",
  },
  {
    action: "saveData",
    value: "suspension",
    type: "eventType",
  },
  {
    action: "saveData",
    value: "adjust",
    type: "subType",
  },
  {
    action: "saveData",
    value: [{ option: "value", value: "2" }],
    type: "options",
  },
  { action: "sendEvent", value: "new", type: "main" },
  { action: "copyEvent", value: "card-clock", type: "to" },
  { action: "copyEvent", value: "card", type: "from" },
];

const startSuspensionClockEvent = (srcEvent) => [
  { action: "copyEvent", value: srcEvent, type: "to" },
  { action: "copyEvent", value: "card-clock", type: "from" },
  { action: "copyData", value: "personId", type: srcEvent },
  { action: "sendEvent", value: "edit", type: "main" },
  { action: "newEventId", value: null, type: "main" },
  {
    action: "saveData",
    value: "start",
    type: "subType",
  },
  {
    action: "clearData",
    value: ["options"],
    type: "main",
  },
  { action: "sendEvent", value: "new", type: "main" },
  { action: "copyEvent", value: "card-clock-start", type: "to" },
  { action: "copyEvent", value: srcEvent, type: "from" },
];

const updateSuspensionClockEvents = (srcEvent) => [
  { action: "copyEvent", value: srcEvent, type: "to" },
  { action: "copyEvent", value: "card-clock", type: "from" },
  { action: "copyData", value: "personId", type: srcEvent },
  { action: "clearData", value: ["flagged"], type: "main" },
  { action: "sendEvent", value: "edit", type: "main" },
  { action: "copyEvent", value: "card-clock-start", type: "from" },
  { action: "copyData", value: "personId", type: srcEvent },
  { action: "clearData", value: ["flagged"], type: "main" },
  { action: "sendEvent", value: "edit", type: "main" },
  { action: "copyEvent", value: srcEvent, type: "from" },
];

const createTwoMinuteSuspension = (value, flagged = false) => [
  {
    actions: [
      { action: "copyEvent", value: "penalty-suspension", type: "to" },
      { action: "copyEvent", value: value, type: "from" },
      { action: "copyData", value: "personId", type: "penalty-suspension" },
      ...(flagged ? [{ action: "saveData", value: true, type: "flagged" }] : []),
      { action: "sendEvent", value: "edit", type: "main" },
      { action: "copyEvent", value: value, type: "to" },
    ],
    conditions: [
      {
        item: "eventDefined",
        value: value,
        operator: "is",
      },
    ],
  },
];

const clearTwoMinuteSuspensionFlag = (value) => [
  {
    actions: [
      { action: "copyEvent", value: "penalty-suspension-before-flag-clear", type: "to" },
      { action: "copyEvent", value: value, type: "from" },
      { action: "clearData", value: ["flagged"], type: "main" },
      { action: "sendEvent", value: "edit", type: "main" },
      { action: "copyEvent", value: value, type: "to" },
      { action: "copyEvent", value: "penalty-suspension-before-flag-clear", type: "from" },
    ],
    conditions: [
      {
        item: "eventDefined",
        value: value,
        operator: "is",
      },
    ],
  },
];

const createRedCardEvent = (eventCountForPerson) => [
  {
    actions: [
      { action: "copyEvent", value: "penalty-suspension", type: "to" },
      { action: "newEvent", value: null, type: "main" },
      { action: "clearData", value: ["flagged"], type: "main" },
      { action: "saveData", value: "redCard", type: "eventType" },
      { action: "sendEvent", value: "new", type: "main" },
      { action: "copyEvent", value: "penalty-suspension", type: "from" },
    ],
    conditions: [
      {
        item: "eventCountForPerson",
        eventType: "suspension",
        count: eventCountForPerson,
        event: "main",
      },
      {
        item: "eventType",
        value: "suspension",
        event: "main",
        operator: "is",
      },
    ],
  },
];

const getPenaltySanctionCompletionGroups = ({ flagged = false } = {}) => [
  ...(flagged
    ? [
        {
          actions: [
            { action: "saveData", value: true, type: "flagged" },
            { action: "clearData", value: ["personId"], type: "main" },
          ],
          conditions: [],
        },
      ]
    : []),
  ...createTwoMinuteSuspension("penalty-suspension-two-min-1", flagged),
  ...createTwoMinuteSuspension("penalty-suspension-two-min-2", flagged),
  {
    actions: [{ action: "deleteFromPlay", value: "redCard", type: "main" }],
    conditions: [
      {
        item: "eventType",
        value: "suspension",
        event: "main",
        operator: "is",
      },
    ],
  },
  // Person-count escalations require a known personId. CONFIRM LATER clears personId, and
  // eventCountForPerson then matches every event with undefined personId — so these groups must
  // stay out of the flagged pipeline.
  ...(flagged
    ? []
    : [...createRedCardEvent(2), ...createRedCardEvent(4)]),

  /* YELLOW CARD */
  {
    actions: [
      { action: "deleteFromPlay", value: "redCard", type: "main" },
      { action: "deleteFromPlay", value: "suspension", type: "main", class: "sport", options: ["all"] },
      { action: "deleteFromPlay", value: "suspension", type: "main", class: "clock", options: ["all"] },
    ],
    conditions: [
      {
        item: "eventType",
        value: "yellowCard",
        event: "main",
        operator: "is",
      },
    ],
  },
  ...(flagged
    ? []
    : [
        {
          actions: [
            { action: "copyEvent", value: "card", type: "to" },
            { action: "newEvent", value: null, type: "main" },
            { action: "clearData", value: ["flagged"], type: "main" },
            { action: "saveData", value: "redCard", type: "eventType" },
            { action: "sendEvent", value: "new", type: "main" },
            { action: "newEvent", value: null, type: "main" },
            { action: "saveData", value: "suspension", type: "eventType" },
            { action: "saveData", value: "twoMinutes", type: "subType" },
            { action: "sendEvent", value: "new", type: "main" },
            { action: "copyEvent", value: "card", type: "from" },
            ...createSuspensionClockEvent(),
            ...startSuspensionClockEvent("card"),
            { action: "copyEvent", value: "card", type: "from" },
          ],
          conditions: [
            {
              item: "eventCountForPerson",
              eventType: "yellowCard",
              count: 1,
              event: "main",
              options: ["ignoreMain"],
            },
            {
              item: "eventType",
              value: "yellowCard",
              event: "main",
              operator: "is",
            },
          ],
        },
      ]),

  /* RED CARD */
  {
    actions: [...createSuspensionClockEvent(), ...startSuspensionClockEvent("card")],
    conditions: [
      {
        item: "eventType",
        value: "redCard",
        event: "main",
        operator: "is",
      },
      {
        item: "eventDefined",
        value: "card-clock-start",
        operator: "not",
      },
    ],
  },
  {
    actions: [...updateSuspensionClockEvents("card")],
    conditions: [
      {
        item: "eventType",
        value: "redCard",
        event: "main",
        operator: "is",
      },
      {
        item: "eventDefined",
        value: "card-clock-start",
        operator: "is",
      },
    ],
  },
  {
    actions: [...startSuspensionClockEvent("penalty-suspension")],
    conditions: [
      {
        item: "eventType",
        value: "suspension",
        event: "main",
        operator: "is",
      },
      {
        item: "eventDefined",
        value: "card-clock-start",
        operator: "not",
      },
    ],
  },
  {
    actions: [...updateSuspensionClockEvents("penalty-suspension")],
    conditions: [
      {
        item: "eventType",
        value: "suspension",
        event: "main",
        operator: "is",
      },
      {
        item: "eventDefined",
        value: "card-clock-start",
        operator: "is",
      },
    ],
  },
  ...(flagged
    ? []
    : [
        ...clearTwoMinuteSuspensionFlag("penalty-suspension-two-min-1"),
        ...clearTwoMinuteSuspensionFlag("penalty-suspension-two-min-2"),
      ]),
  {
    actions: [
      ...(flagged ? [] : [{ action: "clearData", value: ["flagged"], type: "main" }]),
      { action: "sendEvent", value: "edit", type: "main" },
      { action: "copyEvent", value: "penalty-suspension", type: "to" },
      // Push history while main is still the sanction. Loading penalty-shot first would make
      // Go back on penalty-change-goal-keeper restore the goal event onto the sanction panel.
      {
        action: "nextState",
        value: "penalty-change-goal-keeper",
        type: "primary",
      },
      { action: "copyEvent", value: "penalty-shot", type: "from" },
    ],
    conditions: [],
  },
];

export const PenaltySuspensionPlayer = {
  name: "penalty-suspension-player",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "penalty.suspension.select-player",
  showOn: [
    {
      state: "primary",
      value: "penalty-suspension-player",
      operator: "is",
    },
  ],
  allowFlag: true,
  allowCancel: true,
  allowCancelPlay: true,
  cancelActions: [
    {
      actions: [{ action: "clearAllEvents" }],
      conditions: [],
    },
  ],
  showDetails: { events: ["main"] },
  allowBack: { value: "useHistory" },
  children: [
    {
      name: "pre-action",
      component: "PreAction",
      layout: "pre-action",
      mode: "enable",
      text: "",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      actionGroups: [
        {
          actions: [{ action: "copyEvent", value: "penalty-suspension", type: "from" }],
          conditions: [],
        },
      ],
    },
    {
      name: "penalty-suspension-player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      startEvent: false,
      startPlay: false,
      showOn: [true],
      options: {
        currentEntity: true,
        showBench: false,
        showCoach: true,
      },
      actionGroups: getPenaltySanctionCompletionGroups({ flagged: false }),
    },
    {
      name: "confirm-later-penalty-suspension-player-select",
      component: "ButtonPanel",
      layout: "button-group centered",
      mode: "visible",
      showOn: [true],
      children: [
        {
          name: "confirm-later",
          component: "TypeButton",
          layout: "match-button",
          mode: "enable",
          text: "confirmLater",
          showOn: [true],
          startEvent: false,
          startPlay: false,
          actionGroups: getPenaltySanctionCompletionGroups({ flagged: true }),
        },
      ],
    },
  ],
};
